import React, { useMemo, useRef, useState, useEffect } from 'react';
import cn from 'class-names';
import PropTypes from 'prop-types';
import 'intersection-observer';
import { useIsVisible } from 'react-is-visible';
import styles from './HorizontalGallery.module.less';

const Item = ({ onItemRender, index, data, height }) => {
  const nodeRef = useRef();
  const [hover, setHover] = useState(false);
  const isVisible = useIsVisible(nodeRef);

  return (
    <div
      className={cn(isVisible && styles.visible)}
      style={{ height }}
      ref={nodeRef}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {onItemRender({ data, index, hover })}
    </div>
  );
};

const HorizontalGallery = ({ length, dataList, onItemRender, height, scrollLeft, alignCenter, onScroll }) => {
  const elements = useMemo(() => new Array(length).fill(''), [length]);
  const nodeRef = useRef();

  useEffect(() => {
    if (nodeRef.current && typeof scrollLeft === 'number') {
      nodeRef.current.scrollLeft = scrollLeft;
    }
  }, [scrollLeft, nodeRef.current]);

  return (
    <div
      ref={nodeRef}
      className={cn(styles.container, { [styles.centerItem]: alignCenter })}
      style={{ height }}
      onScroll={onScroll && onScroll(nodeRef.current)}
    >
      {elements.map((_, index) => {
        return <Item height={height} key={index} onItemRender={onItemRender} index={index} data={dataList[index]} />;
      })}
    </div>
  );
};

HorizontalGallery.propTypes = {
  length: PropTypes.number.isRequired,
  dataList: PropTypes.array,
  onItemRender: PropTypes.func.isRequired,
  height: PropTypes.string.isRequired,
  scrollLeft: PropTypes.number,
  alignCenter: PropTypes.bool,
  onScroll: PropTypes.func,
};

HorizontalGallery.defaultProps = {
  dataList: [],
  scrollLeft: undefined,
  alignCenter: false,
  onScroll: undefined,
};

export default HorizontalGallery;
